module.exports = __webpack_public_path__ + "img/icon_chat.c03e001a.svg";